import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsselect',
	templateUrl:'./BSSelectPluginCompPage.html',
	styles: [],
	styleUrls:['./BSSelectPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSSelectPluginCompPage
{
	mdContent_862 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.select.BSSelect;
\`\`\``;
	mdContent_863 = `\`\`\`java
BSSelect()
\`\`\``;
	mdContent_864 = `\`\`\`java
BSSelect&lt;?&gt; select = new BSSelect&lt;&gt;();
select.addOption("Choose...", "", true);
select.addOption("Option 1", "1");
select.addOption("Option 2", "2");
select.setSize(BSSizes.Lg);
\`\`\``;
}
